export default function Sports() {
    return (
        <section className="pb-6">
            <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                <div className="text-center mb-10 sm:mb-12 md:mb-14 pt-6 sm:pt-8 md:pt-10">
                    <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl mx-auto font-black max-w-4xl leading-snug text-center text-white">
                        Canales deportivos y competiciones en una sola suscripción
                    </h1>
                </div>
                {(() => {
                    function importAll(requireContext) {    
                        return requireContext.keys().map((key) => ({ key, src: requireContext(key) }));
                    }

                    const sportsContext = require.context('../assets/cover/sports', false, /\.(webp|png|jpe?g|svg)$/);
                    const sportsImages = importAll(sportsContext)
                        .sort((a, b) => a.key.localeCompare(b.key))
                        .map((x) => x.src);
                    const sportsLoop = [...sportsImages, ...sportsImages];

                    const leagueContext = require.context('../assets/cover/league', false, /\.(webp|png|jpe?g|svg)$/);
                    const leagueImages = importAll(leagueContext)
                        .sort((a, b) => a.key.localeCompare(b.key))
                        .map((x) => x.src);
                    const leagueLoop = [...leagueImages, ...leagueImages];

                    return (
                        <>
                            <div className="sports-carousel">
                                <div className="sports-marquee">
                                    <div className="sports-track">
                                        {sportsLoop.map((src, index) => (
                                            <div className="sports-item" key={`sport-${index}`}><img src={src} alt={`Sport ${index + 1}`} /></div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="league-carousel mb-12 sm:mb-16 mt-6 sm:mt-8">
                                <div className="channel-marquee">
                                    <div className="channel-track">
                                        {leagueLoop.map((src, index) => (
                                            <div className="channel-item" key={`league-${index}`}>
                                                <img src={src} alt={`League ${index + 1}`} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    );
                })()}
            </div>
        </section>
    );
}
